import React, { Component } from "react";
import { Col, FormGroup, Form } from "reactstrap";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { FormControl } from 'react-bootstrap';

import SuratIzinKeramainan from "./SuratIzinKeramainan";
import SuratKeteranganUsaha from "./SuratKeteranganUsaha";
import SuratKeteranganUsahaV2 from "./SuratKeteranganUsahaV2";
import SuratKeteranganDomisili from "./SuratKeteranganDomisili";
import SuratKeteranganDomisiliV2 from "./SuratKeteranganDomisiliV2";
import SuratJalan from "./SuratJalan";
import SuratKeteranganAhliWaris from "./SuratKeteranganAhliWaris";
import SuratKeteranganAhliWarisV2 from "./SuratKeteranganAhliWarisV2";
import SuratKelahiran from "./SuratKelahiran";
import SuratKelahiranV2 from "./SuratKelahiranV2";
import SuratBelumMemilikiRumah from "./SuratBelumMemilikiRumah";
import SuratKematian from "./SuratKematian";
import SuratKematianV2 from "./SuratKematianV2";
import SuratKepemilikanRumah from "./SuratKepemilikanRumah";
import SuratPernahMenikah from "./SuratPernahMenikah";
import SuratPenghasilan from "./SuratPenghasilan";
import SuratTidakMampu from "./SuratTidakMampu";
import SuratKuasaSKGR from "./SuratKuasaSKGR";
import SuratPindahNikah from "./SuratPindahNikah";
import SuratSKCK from "./SuratSKCK";
import SuratBelumMenikah from "./SuratBelumMenikah";
import SuratBelumMenikahV2 from "./SuratBelumMenikahV2";
import SuratKehilangan from "./SuratKehilangan";
import SuratTidakMenikah from "./SuratTidakMenikah";
import ModalGenerateForm from "./SuratGenerateForm";

import API_URL, {
  Get,
  GetAwait,
  JENIS_DESA,
  KECAMATAN,
  Nama_DESA,
  NAMA_KABUPATEN,
  Post,
  PROVINSI,
  PostDemo
} from "../function/Koneksi";
import { GetJenisSurat } from "../function/jenis-surat";
import Modal from "react-responsive-modal";
import Iframe from "react-iframe";
// import SuratPenghasilan from './SuratPenghasilan';
// import SuratTidakMampu from './SuratTidakMampu';
// import SuratKuasaSKGR from './SuratKuasaSKGR';
// import SuratSKCK from './SuratSKCK';
import "../assets/css/site.css";

import SweetAlert from "react-bootstrap-sweetalert/lib/dist/SweetAlert";
// import SuratKehilangan from './SuratKehilangan';
// import SuratPernahMenikah from './SuratPernahMenikah';
// import SuratPindahNikah from './SuratPindahNikah';
import { Redirect } from "react-router-dom";

let LIST_LAYANAN_DESA = JSON.parse(localStorage.getItem("LAYANAN_DESA"));
export default class Layanan extends Component {
  constructor(props) {
    super(props);
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.state = {
      navigate: false,
      status: {
        frmNomorAntrian: false,
        modalKodePengajuan: false,
        modalKonfirmasi: false,
        modalKonfirmasi2: false,
        modalKonfirmasiPembatalan: false,
        messageAntrian: "",
        messageAntrian2: true,
        jenisSurat: "",
        statusSurat: "",
        frmPrintKonfirmasi: false,
        frmPreviewDraft: false,
        frmPrint: false,
        frmCekPengajuan: false,
        modalStatusTerakhir: false,
        frmShowDetailPengajuan: false
      },
      layanan: [],
      perizinan: [],
      show: false,
      basicType: "info",
      basicTitle: "",
      pesanAlert: "",
      nomorAntrian: 0,
      anggotaKeluarga: [],
      tmplistPenduduk: [],
      listAgama: [],
      listPekerjaan: [],
      listShdk: [],
      listShdkLabel: [],

      // Loading
      loading: true,
      loadingPreview: false,

      get_data_surat: [],
      get_jenis_surat: "",
      data_cek: "",
      layanan_jenis: true,
      cek_pengajuan: false,

      layananSuratBaru: [],
      layananSuratBaruPermanent: [],
      cariSurat: "",
    };
  }

  logOut(e) {
    e.preventDefault();
    // sessionStorage.removeItem('access_token');
    this.setState({ navigate: true });
  }

  getPreData = async () => {
    const dataPenduduk = this.props.location.state;

    // Data KK
    const dataKK = await GetAwait(
      "penduduk/kk/" + dataPenduduk.results.id_kk,
      null
    );
    // Data Agama
    const dataAgama = await GetAwait("agama/list", null);
    // Data Pekerjaan
    const dataPekerjaan = await GetAwait("pekerjaan/list", null);
    // Data Shdk
    const dataShdk = await GetAwait("shdk/list", null);
    // Data Status Perkawinan
    const dataStatusPerkawinan = await GetAwait(
      "select-enum/penduduk/status_perkawinan",
      null
    );

    // Jika data KK berhasil
    if (dataKK.data.results) {
      let anggotaKeluarga = [];
      let tmplistPenduduk = {};
      dataKK.data.results.forEach(dt => {
        anggotaKeluarga.push({
          value: dt.id,
          label: dt.id + " (" + dt.nama + ")"
        });
        tmplistPenduduk = {
          ...tmplistPenduduk,
          [dt.id]: dt
        };
      });
      this.setState({ anggotaKeluarga, tmplistPenduduk });

      // Jika dataAgama berhasil
      if (dataAgama.data.results) {
        let listAgama = [];
        dataAgama.data.results.forEach(dt => {
          listAgama.push({ value: dt.uuid, label: dt.nama });
        });
        this.setState({ listAgama });
      }

      // Jika dataPekerjaan berhasil
      if (dataPekerjaan.data.results) {
        let listPekerjaan = [];
        dataPekerjaan.data.results.forEach(dt => {
          listPekerjaan.push({ value: dt.uuid, label: dt.nama });
        });
        this.setState({ listPekerjaan });
      }

      // Jika dataShdk berhasil
      if (dataShdk.data.results) {
        let listShdk = [];
        let listShdkLabel = [];
        dataShdk.data.results.forEach(dt => {
          listShdk.push({ value: dt.uuid, label: dt.nama });
          listShdkLabel.push({ value: dt.nama, label: dt.nama });
        });
        this.setState({ listShdk, listShdkLabel });
      }

      // Jika dataStatusPerkawinan berhasil
      if (dataStatusPerkawinan.data) {
        let listStatusPerkawinan = [];
        dataStatusPerkawinan.data.forEach(dt => {
          listStatusPerkawinan.push({ value: dt, label: dt });
        });
        this.setState({ listStatusPerkawinan });
      }

      // Get jenis surat
      this.getData();
    }
  };

  componentDidMount() {
    LIST_LAYANAN_DESA = JSON.parse(localStorage.getItem("LAYANAN_DESA"));

    Get("list-jenis-surat-main", null, lihat => {
      if (lihat.results) {
        this.setState({
          layananSuratBaru: lihat.results,
          layananSuratBaruPermanent: lihat.results,
          loadingListLayananMasyarakat: false
        });
      } else {
        this.setState({
          loadingListLayananMasyarakat: false
        });
      }
    });

    if (
      LIST_LAYANAN_DESA.layanan_kiosk === "undefined" ||
      LIST_LAYANAN_DESA.layanan_kiosk === null ||
      LIST_LAYANAN_DESA.layanan_kiosk === "[]" ||
      LIST_LAYANAN_DESA.layanan_kiosk === ""
    ) {
      this.setState({
        data_cek: "Kosong"
      });
      this.forceUpdate();
    } else {
      this.setState({
        data_cek: "Tidak Kosong"
      });
      this.forceUpdate();
    }

    if (navigator.onLine) {
      // Get data ws
      this.getPreData();
    } else {
      this.setState({
        show: true,
        basicType: "info",
        basicTitle: "Login",
        pesanAlert: "Jaringan internet tidak aktif..."
      });
    }
  }

  getData = (fil = null) => {
    if (fil) {
      let filJenisSurat = {
        nama: fil
      };
      PostDemo("jenis-surat/list", null, filJenisSurat, data => {
        // data.data.results.forEach((dt) => {
        // 	if (dt.kategori === 'Layanan Masyarakat') {
        // 		layanan.push(dt);
        // 	}
        // 	if (dt.kategori === 'Perizinan Masyarakat') {
        // 		perizinan.push(dt);
        // 	}
        // });
        this.setState({
          layanan: data.data.results,
          perizinan: data.data.results,
          loading: false
        });
      });
    } else {
      Get("jenis-surat/list", null, data => {
        //console.log(data);
        if (typeof data !== "undefined") {
          // data.results.forEach((dt) => {
          // 	if (dt.kategori === 'Layanan Masyarakat') {
          // 		layanan.push(dt);
          // 	}
          // 	if (dt.kategori === 'Perizinan Masyarakat') {
          // 		perizinan.push(dt);
          // 	}
          // });
          this.setState({
            layanan: data.results,
            perizinan: data.results,
            loading: false
          });
        }

        // //console.log(this.state.layanan);
      });
    }
  };

  isComplete = (stat, noted = null) => {
    if (stat === false) {
      if (noted !== null) {
        this.setState({
          show: true,
          basicType: "info",
          basicTitle: "Data Surat",
          pesanAlert:
            "Pemohon memiliki catatan yang belum selesai, hubungi petugas kantor " +
            JENIS_DESA.toLowerCase() +
            " untuk info lebih lanjut"
        });
      } else {
        this.setState({
          show: true,
          basicType: "info",
          basicTitle: "Data Surat",
          pesanAlert:
            "Data Surat Belum Lengkap. Silahkan lengkapi seluruh data yang dibutuhkan pada kolom yang tersedia"
        });
      }
    }
  };

  getJenisSuratCard = data => {
    let cek_jenis = GetJenisSurat(data);
    let set_jenis = "cetak-surat/" + cek_jenis + "/";

    if (cek_jenis == null) {
      set_jenis = data.route_surat.slice(1);
    }

    this.setState({
      get_jenis_surat: set_jenis
    });
  };
  getDataSuratCard = data => {
    this.setState({
      get_data_surat: data
    });
  };
  getNomorAntrian = (jenis_surat, status, uncomplete = false, data) => {
    this.setState({ loadingPreview: false });
    if (status === "berhasil") {
      let cek_jenis = GetJenisSurat(jenis_surat);
      let set_jenis = "cetak-surat/" + cek_jenis + "/";

      if (cek_jenis == null) {
        set_jenis = jenis_surat.route_surat.slice(1);
        jenis_surat = jenis_surat.nama_alias;
      }

      let layanan_jenis = false;
      this.state.layananSuratBaru.forEach(dt => {
        if (dt.nama_alias === jenis_surat) {
          if (
            dt.pengaturan_surat &&
            dt.pengaturan_surat.layanan_apm === 1 &&
            dt.pengaturan_surat.cetak_layanan_kiosk === 1
          ) {
            layanan_jenis = true;
          }
        }
      });

      this.setState({
        status: {
          ...this.state.status,
          jenisSurat: jenis_surat + " Berhasil Dibuat",
          messageAntrian: "Cetak Surat Anda Sekarang?"
        }
      });

      if (layanan_jenis === true && set_jenis) {
        this.setState({
          status: {
            ...this.state.status,
            frmPreviewDraft: true,
            // frmPrintKonfirmasi: true,
            modalKonfirmasi: false
          },
          layanan_jenis: true
        });
      } else {
        this.setState({
          status: {
            ...this.state.status,
            frmPrintKonfirmasi: false,
            frmPreviewDraft: true
            // modalKodePengajuan: true,
            // modalKonfirmasi: true,
          },
          layanan_jenis: false
        });
      }
      this.setState({
        status: {
          ...this.state.status,
          statusSurat: status
        },
        get_data_surat: data,
        get_jenis_surat: set_jenis
      });
      this.forceUpdate();
      // Post('antrian/create', null, data, (res) => {
      // 	// //console.log(data);
      // 	//console.log(res);
      // 	if (res.status ==== 201) {
      // 		this.state.nomorAntrian = res.data.results.nomor;
      // 		this.state.status.jenisSurat = jenis_surat;
      // 		this.state.status.messageAntrian =
      // 			'Silahkan menunggu nomor antrian anda dipanggil untuk mengambil surat. Terima kasih';
      // 		this.state.status.frmNomorAntrian = true;
      // 		this.state.status.statusSurat = status;
      // 		this.forceUpdate();
      // 	} else {
      // 		this.state.show = true;
      // 		this.state.basicType = 'info';
      // 		this.state.basicTitle = 'Data Surat';
      // 		this.state.pesanAlert =
      // 			'Mohon maaf, surat anda tidak berhasil diajukan. Mohon ajukan surat lagi atau hubungi pegawai di kantor ' + JENIS_DESA.toLowerCase() + '.';
      // 		this.state.status.statusSurat = status;
      // 		this.forceUpdate();
      // 	}
      // });
    } else if (status === "cari nik") {
      this.setState({
        show: true,
        basicType: "info",
        basicTitle: "Data Tidak Ditemukan",
        pesanAlert: "Silahkan Periksa Kembali NIK"
      });
    } else if (status === "cek digit nik") {
      this.setState({
        show: true,
        basicType: "warning",
        basicTitle: "NIK yang anda masukkan Salah",
        pesanAlert: "Jumlah angka NIK kurang 16 angka. Silahkan cek NIK kembali"
      });
    } else if (status === "cekDataPewaris") {
      this.setState({
        show: true,
        basicType: "info",
        basicTitle: "Data Ahli Waris",
        pesanAlert:
          "Silahkan pilih NIK dan hubungan keluarga sebelum menambahkan data pewaris"
      });
    } else if (status === "cekDataPengikut") {
      this.setState({
        show: true,
        basicType: "info",
        basicTitle: "Data " + jenis_surat,
        pesanAlert:
          "Silahkan pilih NIK dan hubungan keluarga sebelum menambahkan data pengikut"
      });
    } else if (status === "cekDataShdk") {
      this.setState({
        show: true,
        basicType: "info",
        basicTitle: "Data Status Hubungan Dalam Keluarga",
        pesanAlert:
          "Silahkan pilih status hubungan dalam keluarga sebelum menambahkan data"
      });
    } else {
      if (uncomplete) {
        this.setState({
          show: true,
          basicType: "info",
          basicTitle: "Data Surat",
          pesanAlert:
            "Data Belum Lengkap. Silahkan Lengkapi Seluruh Data yang diperlukan"
        });
      } else {
        this.setState({
          show: true,
          basicType: "info",
          basicTitle: "Data Surat",
          pesanAlert:
            "Mohon maaf, surat anda tidak berhasil diajukan. Mohon ajukan surat lagi atau hubungi pegawai di kantor " +
            JENIS_DESA.toLowerCase() +
            "."
        });
      }
    }

    this.setState({
      status: {
        ...this.state.status,
        statusSurat: status
      }
    });
    this.forceUpdate();
  };

  tutupForm = () => {
    this.setState({
      status: {
        ...this.state.status,
        frmNomorAntrian: false,
        frmPrintKonfirmasi: false
      }
    });
    // this.state.status.modalKonfirmasi = true;
    // this.state.status.messageAntrian2 = true;
    this.forceUpdate();
  };

  cetakAntrian = () => {
    // let halaman_antrian = document.getElementById('halaman_print_antrian');
    // let antrian = document.getElementById('kertas_antrian').contentWindow;

    // antrian.document.open();
    // antrian.document.write(halaman_antrian.innerHTML);
    // antrian.document.close();
    // antrian.focus();
    // antrian.print();
    // window.print();
    // const printContents = document.getElementById('kertas_antrian').innerHTML;
    // const originalContents = document.body.innerHTML;

    // document.body.innerHTML = printContents;

    window.print();

    // document.body.innerHTML = originalContents;
  };

  nextSlide() {
    this.slider.slickNext();
  }

  prevSlide() {
    this.slider.slickPrev();
  }

  tutupCariPengajuan = () => {
    this.setState({
      status: {
        ...this.state.status,
        frmCekPengajuan: false
      }
    });

    this.forceUpdate();
  };

  batalPengajuan = () => {
    this.setState({ loadingPreview: true });
    let addData = {
      status: "Batal"
    };

    Post(
      "surat-keterangan/grup/update-status",
      this.state.get_data_surat.uuid_surat,
      addData,
      res => {
        // console.log('respon batal')
        // console.log(res)
        if (res.status === 200) {
          setTimeout(
            function() {
              this.setState({
                loadingPreview: false,
                show: true,
                basicType: "success",
                basicTitle: "Pembatalan Pengajuan Surat",
                pesanAlert: "Berhasil Batalkan Pengajuan",
                successAlert: true,
                status: {
                  ...this.state.status,
                  frmPreviewDraft: false,
                  modalKonfirmasiPembatalan: false,
                  modalKonfirmasi: true
                }
              });
            }.bind(this),
            1000
          );
        } else {
          this.setState({
            loadingPreview: false,
            show: true,
            basicType: "danger",
            basicTitle: "Pembatalan Pengajuan Surat",
            pesanAlert: "Gagal Batalkan Pengajuan"
          });
        }
        // reset cache
        // document.getElementById('tujuan_pembuatan').value = '';
        // document.getElementById('lokasi').value = '';
      }
    );
  };
  cariPengajuan = e => {
    e.preventDefault();

    this.setState({
      loadingPreview: true
    });

    this.forceUpdate();

    let kode_pengajuan = document.getElementById("kode_pengajuan").value;

    // console.log('kode_pengajuan')
    // console.log(kode_pengajuan)

    Get(
      "surat-keterangan/grup/find/kode-surat/" + kode_pengajuan,
      null,
      res => {
        if (res.results) {
          setTimeout(
            function() {
              // reset cache
              document.getElementById("kode_pengajuan").value = "";

              // let set_jenis = res.results.data_master_jenis.route_surat.slice(1, -1)
              let set_jenis = res.results.data_master_jenis.route_surat.slice(
                1
              );

              this.setState({
                status: {
                  ...this.state.status,
                  frmCekPengajuan: false,
                  modalStatusTerakhir: true
                },
                get_jenis_surat: set_jenis,
                get_data_surat: {
                  uuid_surat: res.results.uuid,
                  kode_surat: res.results.kode_surat,
                  status_pengajuan: res.results.data_status_terakhir.status
                },
                loadingPreview: false
              });
            }.bind(this),
            1000
          );
        } else {
          this.setState({
            loadingPreview: false,
            show: true,
            basicType: "danger",
            basicTitle: "Pencarian Status Pengajuan Surat",
            pesanAlert:
              "Data Tidak Ditemukan, Pastikan Kode Pengajuan Anda Benar"
          });
        }
      }
    );
  };

  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  // CARI DATA SURAT
  cariLayanan = e => {
    if (e.key === "Enter") {
      this.setState({
        loading: true
      });

      let filterData = this.state.layananSuratBaruPermanent.filter(dt =>
        dt.nama_surat.toLowerCase().includes(e.target.value.toLowerCase())
      );

      this.setState({
        layananSuratBaru: filterData,
        cariSurat: e.target.value
      });

      setTimeout(
        function() {
          this.setState({
            loading: false
          });
        }.bind(this),
        500
      );
    }
  };

  render() {
    // console.log(this.props)
    // console.log(this.state.cek_pengajuan)
    // console.log(this.state.layanan_jenis)
    // console.log(this.state)

    //console.log("List Layanan");
    //console.log(LIST_LAYANAN_DESA);
    //console.log(LIST_LAYANAN_DESA.cetak_layanan_kiosk);

    const footerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };

    if (
      this.state.navigate ||
      typeof this.props.location.state === "undefined"
    ) {
      return <Redirect to="/" push={true} />;
    }

    const background = require("../assets/images/auth-layer.png");

    const dataPenduduk = this.props.location.state;

    let countLayanan = 0;

    const tampilLayananMasyarakat = this.state.layananSuratBaru.map(dt => {
      let condition = false;
      let status_generate = true;
      if (
        dt.jenis_layanan === "Masyarakat" &&
        dt.pengaturan_surat &&
        dt.pengaturan_surat.layanan_apm === 1
      ) {
        condition = true;
        countLayanan += 1
        if (dt.status_generate_form !== "true") {
          status_generate = false;
        }
      }

      if (condition) {
        if (status_generate) {
          return (
            <ModalGenerateForm
              data={dataPenduduk}
              anggotaKeluarga={this.state.anggotaKeluarga}
              tmplistPenduduk={this.state.tmplistPenduduk}
              id_jenis={dt.uuid}
              getJenisSuratCard={jenis_surat =>
                this.getJenisSuratCard(jenis_surat)
              }
              detailSurat={dt}
              getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
              isComplete={stat => this.isComplete(stat)}
              getAntrian={(jenis_surat, status, uncomplete, data) =>
                this.getNomorAntrian(jenis_surat, status, uncomplete, data)
              }
              setLoadingPreview={e => {
                this.setState({ loadingPreview: e });
              }}
            />
          );
        } else {
          let nama = dt.nama_alias.toLowerCase();

          // console.log(nama)
          switch (nama) {
            case "surat izin keramaian":
              return (
                <SuratIzinKeramainan
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat pengantar pindah nikah":
              return (
                <SuratPindahNikah
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listAgama={this.state.listAgama}
                  listPekerjaan={this.state.listPekerjaan}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan domisili":
              return (
                <SuratKeteranganDomisili
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat domisili":
              return (
                <SuratKeteranganDomisiliV2
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan usaha":
              return (
                <SuratKeteranganUsaha
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat usaha":
              return (
                <SuratKeteranganUsahaV2
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan jalan":
              return (
                <SuratJalan
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan ahli waris":
              return (
                <SuratKeteranganAhliWaris
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan ahli waris pandau":
              return (
                <SuratKeteranganAhliWarisV2
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan kelahiran":
              return (
                <SuratKelahiran
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listAgama={this.state.listAgama}
                  listPekerjaan={this.state.listPekerjaan}
                  listShdk={this.state.listShdk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan kelahiran v2":
              return (
                <SuratKelahiranV2
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listAgama={this.state.listAgama}
                  listPekerjaan={this.state.listPekerjaan}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan belum memiliki rumah":
              return (
                <SuratBelumMemilikiRumah
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan kematian":
              return (
                <SuratKematian
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  listShdkLabel={this.state.listShdkLabel}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan kematian v2":
              return (
                <SuratKematianV2
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan penghasilan":
              return (
                <SuratPenghasilan
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan tidak mampu":
              return (
                <SuratTidakMampu
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat kuasa skgr":
              return (
                <SuratKuasaSKGR
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listPekerjaan={this.state.listPekerjaan}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat pengantar skck":
              return (
                <SuratSKCK
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat pernyataan kehilangan":
              return (
                <SuratKehilangan
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan pernah menikah":
              return (
                <SuratPernahMenikah
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listAgama={this.state.listAgama}
                  listPekerjaan={this.state.listPekerjaan}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={(stat, noted) => this.isComplete(stat, noted)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan kepemilikan rumah":
              return (
                <SuratKepemilikanRumah
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat pernyataan belum menikah":
              return (
                <SuratBelumMenikah
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listShdk={this.state.listShdk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat keterangan belum menikah":
              return (
                <SuratBelumMenikahV2
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  listShdk={this.state.listShdk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            case "surat pernyataan tidak menikah":
              return (
                <SuratTidakMenikah
                  data={dataPenduduk}
                  anggotaKeluarga={this.state.anggotaKeluarga}
                  tmplistPenduduk={this.state.tmplistPenduduk}
                  id_jenis={dt.uuid}
                  getJenisSuratCard={jenis_surat =>
                    this.getJenisSuratCard(jenis_surat)
                  }
                  detailSurat={dt}
                  getDataSurat={data_surat => this.getDataSuratCard(data_surat)}
                  isComplete={stat => this.isComplete(stat)}
                  getAntrian={(jenis_surat, status, uncomplete, data) =>
                    this.getNomorAntrian(jenis_surat, status, uncomplete, data)
                  }
                  setLoadingPreview={e => {
                    this.setState({ loadingPreview: e });
                  }}
                />
              );

            default:
              return null;
          }
        }
      } else {
        return null;
      }
    });

    const rowTotal = countLayanan <= 4 ? 1 : 2;

    const Merge_settings = {
      className: "center",
      dots: true,
      infinite: true,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      rows: rowTotal,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            rows: 5,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 980, // Untuk layar lebih kecil
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 4, // Scroll lebih banyak ke bawah
            slidesPerRow: 1,
            dots: true,
            infinite: true
          }
        },
        {
          breakpoint: 680, // Untuk layar sangat kecil
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 4, // Scroll lebih banyak ke bawah
            slidesPerRow: 1,
            dots: true,
            infinite: true
          }
        }
      ]
    };

    let logoAplikasi = (
      <img
        src={require("../assets/images/logo-ld.webp").default}
        alt="logo"
        style={{
          height: "35px"
          // width: '45px',
          // marginTop: '-10px'
        }}
      />
    );

    switch (localStorage.getItem("JENIS_APLIKASI").toLowerCase()) {
      case "halaman kampung":
        logoAplikasi = (
          <img
            src={require("../assets/images/hk_icon.png")}
            alt="logo"
            style={{
              height: "35px"
              // width: '45px',
              // marginTop: '-10px'
            }}
          />
        );
        break;
      case "amanat nagari":
        logoAplikasi = (
          <img
            src={require("../assets/images/amanat_nagari_logo.png")}
            alt="logo"
            style={{
              height: "35px"
              // width: '45px',
              // marginTop: '-10px'
            }}
          />
        );
        break;
      default:
        logoAplikasi = (
          <img
            src={require("../assets/images/logo-ld.webp").default}
            alt="logo"
            style={{
              height: "35px"
              // width: '45px',
              // marginTop: '-10px'
            }}
          />
        );
        break;
    }

    return (
      <>
        {/* page wrapper */}
        <div
          id="bg-kiosk"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly"
          }}
        >
          {/* page header */}
          <div className="row d-flex justify-content-center align-items-center p-relative">
            {/* page heading */}
            <div
              style={{
                borderRadius: "45px",
                padding: "1em 2em",
                boxShadow: "0 4px 8px 0 #0000003d, 0 6px 20px 0 #0000003d"
              }}
            >
              <div
                className="d-flex align-items-center"
                style={{
                  gap: "10px"
                }}
              >
                {logoAplikasi}
                <span
                  style={{
                    fontSize: "1.7em",
                    color: "#ffffff",
                    fontWeight: "600"
                  }}
                >
                  Kios Pelayanan Masyarakat
                </span>
              </div>
            </div>
            {/* status pengajuan button */}
            <div
              style={{
                position: "absolute",
                top: 15,
                left: 40,
                borderRadius: "45px",
                padding: "0.5em 1em",
                backgroundColor: "#3d5fac",
                boxShadow: "0 4px 8px 0 #0000003d, 0 6px 20px 0 #0000003d",
                cursor: "pointer"
              }}
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    frmCekPengajuan: true
                  }
                });
                this.forceUpdate();
              }}
            >
              <h5
                style={{
                  fontSize: "1.2em",
                  color: "#ffffff",
                  fontWeight: "500",
                  marginBottom: "0px"
                }}
              >
                <i className="fa fa-search"></i> Cek Status Pengajuan
              </h5>
            </div>
            <div
              className="logout-kiosk"
              style={{
                position: "absolute",
                top: 15,
                right: 40,
                borderRadius: "45px",
                padding: "0.5em 1em",
                backgroundColor: "#ff0000",
                boxShadow: "0 4px 8px 0 #0000003d, 0 6px 20px 0 #0000003d",
                cursor: "pointer"
              }}
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    modalKonfirmasi2: true
                  }
                });
                this.forceUpdate();
              }}
            >
              <h5
                style={{
                  fontSize: "1.2em",
                  color: "#ffffff",
                  fontWeight: "500",
                  marginBottom: "0px"
                }}
              >
                Keluar
              </h5>
            </div>
          </div>

          <div className="row d-flex justify-content-center align-items-center p-relative">
            <div
              className="col-12"
              style={{
                width: "100%",
                maxWidth: "600px"
              }}
            >
              <input
                type="text"
                className="form-control"
                id="cariLayananSurat"
                placeholder="Cari Berdasarkan Nama Surat ..."
                defaultValue={this.state.cariSurat}
                onKeyPress={this.cariLayanan}
                style={{
                  borderRadius: "50px",
                  textAlign: "center"
                }}
              />
            </div>
          </div>

          {this.state.loading ? (
            <div className="row">
              <div className="col-sm-12" align="center">
                <img
                  alt=""
                  src={require("../assets/images/tes-loading.gif")}
                  style={{
                    // width: "100%",
                    borderRadius: "10px",
                    width: "100px"
                  }}
                />
              </div>
            </div>
          ) : (
            <>
              <div style={{ padding: "0px 15px" }}>
                {this.state.data_cek === "Kosong" ? (
                  <>
                    <div align="center">
                      <div
                        style={{
                          width: "53%",
                          height: "max-content",
                          // width: '627px',
                          // height: '346px',
                          // marginLeft: '65px',
                          // marginTop: '18px',
                          borderRadius: "19px",
                          backgroundSize: "cover",
                          backgroundImage: `url(${background})`
                        }}
                      >
                        <div style={{ padding: "59px 75px 55px 75px" }}>
                          <h4>
                            Layanan Tidak Tersedia, <br />
                            Silahkan Hubungi Admin
                          </h4>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {this.state.layananSuratBaru.length > 0 ? (
                      <>
                        {/* slider */}
                        <Slider
                          ref={c => (this.slider = c)}
                          {...Merge_settings}
                        >
                          {tampilLayananMasyarakat}
                        </Slider>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            textAlign: "center",
                            marginTop: "30px"
                          }}
                        >
                          <button
                            className="btn btn-primary-custom"
                            onClick={this.prevSlide}
                          >
                            Sebelumnya
                          </button>
                          <button
                            className="btn btn-primary-custom"
                            onClick={this.nextSlide}
                          >
                            Selanjutnya
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="card kiosk-card mx-auto"
                          onClick={e => {
                            this.setState({
                              loading: true,
                              cariSurat: "",
                              layananSuratBaru: this.state
                                .layananSuratBaruPermanent
                            });
                            document.getElementById("cariLayananSurat").value =
                              "";
                            setTimeout(
                              function() {
                                this.setState({
                                  loading: false
                                });
                              }.bind(this),
                              1000
                            );
                          }}
                          style={{
                            marginTop: "20px",
                            marginBottom: "20px",
                            height: "170px",
                            minWidth: "max-content",
                            borderRadius: "20px",
                            width: "100%",
                            maxWidth: "333px",
                            justifyContent: "center",
                            position: 'relative',
                          }}
                        >
                          <div className="card-body">
                            <div
                              className="row"
                              style={{ justifyContent: "center", margin: '0', position: 'absolute', top: '50%', paddingLeft: '10%', transform: "translateY(-50%)" }}
                            >
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  color: "#000000",
                                  textAlign: 'center',
                                }}
                              >
                                Layanan Tidak Ada !
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          )}

          <div
            className="row"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <h5
              style={{
                fontSize: "1em",
                color: "#ffffff",
                textShadow: "1px 0px 5px #000000"
              }}
            >
              Kantor {Nama_DESA}, {KECAMATAN}, {NAMA_KABUPATEN}, {PROVINSI}
            </h5>
            <h5
              style={{
                fontSize: "1em",
                color: "#ffffff",
                textShadow: "1px 0px 5px #000000"
              }}
            >
              © PT. Bumi Manusia Sadparamita, Karawang, Jawa Barat.
            </h5>
          </div>
        </div>
        {/* <SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					cancelBtnBsStyle="info"
					onCancel={() => {
						this.setState({
							show: false
						});
					}}
					showConfirm={false}
				>
					{this.state.pesanAlert}
				</SweetAlert> */}

        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>

        {/* Modal Nomor Antrian */}
        <Modal
          open={this.state.status.frmNomorAntrian}
          // open={true}
          // open={true}
          // onClose={false}
          styles={{ modal: { width: "400px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            id="kertas_antrian"
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              <h4>{this.state.status.jenisSurat}</h4>
            </div>
            <div
              style={{
                // width: 'fit-content',
                padding: "10px 25px",
                margin: "10px 30px",
                borderRadius: "35px",
                border: "5px solid"
                // display: this.state.status.messageAntrian2 ? '' : 'none'
              }}
            >
              <div className="row" style={{ textAlign: "center" }}>
                <div className="col-sm-12">
                  <h5 style={{ fontSize: "25px" }}>No. Antrian Anda</h5>
                </div>
              </div>
              <div className="row" style={{ textAlign: "center" }}>
                <div className="col-sm-12">
                  <h1 style={{ fontSize: "60px" }}>
                    {this.state.nomorAntrian}
                  </h1>
                </div>
              </div>
            </div>
            <div className="row" style={{ textAlign: "center" }}>
              <h5 style={{ fontSize: "22px" }}>
                Silahkan menunggu nomor antrian anda dipanggil untuk mengambil
                surat. Terima kasih
              </h5>
              {/* <h5 style={{ fontSize: '22px' }}>{this.state.status.messageAntrian}</h5> */}
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                // this.tutupForm();
                this.cetakAntrian();
                this.setState({
                  status: {
                    ...this.state.status,
                    frmNomorAntrian: false,
                    modalKonfirmasi: true
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-info"
            >
              Cetak Nomor Antrian
            </button>
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    frmNomorAntrian: false,
                    modalKonfirmasi: true
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-success"
            >
              Tutup
            </button>
          </div>
        </Modal>
        {/* End Modal Nomor Antrian */}

        {/* Modal Konfirmasi Cetak */}
        <Modal
          open={this.state.status.frmPrintKonfirmasi}
          // open={true}
          // open={true}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                frmPrintKonfirmasi: false,
                modalKonfirmasi: true
              }
            });
          }}
          styles={{ modal: { width: "800px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            id="kertas_antrian"
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              <h4>{this.state.status.jenisSurat}</h4>
            </div>

            <div className="row" style={{ textAlign: "center" }}>
              <h5 style={{ fontSize: "22px" }}>
                Apakah Anda Ingin Mencetak Surat Yang Telah Anda Buat?
              </h5>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    frmPrintKonfirmasi: false,
                    modalKonfirmasi: true
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-warning"
            >
              Tutup
            </button>

            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    frmPrintKonfirmasi: false,
                    frmPrint: true
                  },
                  loadingPreview: true
                });
                // this.tutupForm();
                // this.cetakAntrian();
                // this.state.status.modalKonfirmasi = true;
                // this.cetakSurat()
                this.forceUpdate();
              }}
              className="btn btn-info"
            >
              Cetak Sekarang
            </button>
          </div>
        </Modal>
        {/* End Modal Konfirmasi Cetak */}

        {/* Loading */}
        <SweetAlert
          show={this.state.loadingPreview}
          showCancel={false}
          showConfirm={false}
        >
          <div align="center">
            <h5
              className="modal-title"
              style={{ textAlign: "center", color: "black" }}
            >
              Sedang Dalam Proses
            </h5>
            <br />
            <img
              alt="loading"
              src={require("../assets/images/tes-loading.gif")}
              style={{
                // width: "100%",
                borderRadius: "10px",
                width: "150px"
              }}
            />
            <br />
            <br />
          </div>
        </SweetAlert>
        {/* End Loading */}

        {/* Modal Preview Draft Surat */}
        <Modal
          classNames={{ overlay: "custom-map-modal" }}
          open={this.state.status.frmPreviewDraft}
          onClose={() => {
            // this.setState({
            // 	status:{
            // 		...this.state.status,
            // 		modalKonfirmasi: true,
            // 		frmPreviewDraft: false,
            // 	}
            // })
          }}
          styles={{
            modal: {
              width: "100%",
              height: "100%",
              maxHeight: "unset",
              maxWidth: "unset"
            }
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              height: "90%",
              alignItems: "center"
            }}
          >
            <center>
              <span>
                <h4>
                  <b>
                    Berikut adalah draft surat yang telah anda ajukan,
                    <br /> silahkan cek kelengkapan data anda sebelum
                    melanjutkan!
                  </b>
                </h4>
              </span>
              <br />
            </center>

            <Iframe
              id="myFrame"
              src={
                API_URL +
                // 'cetak-surat/' +
                this.state.get_jenis_surat +
                // '/' +
                this.state.get_data_surat.uuid_surat +
                "?show=Ya&status_preview=ya#toolbar=0"
              }
              // styles={
              // 	{display: 'none'}
              // }
              onLoad={e => {
                this.setState({
                  loadingPreview: false
                });
              }}
              width="100%"
              height="100%"
              className="myClassname"
              display={this.state.loadingPreview ? "none" : "block"}
              position="relative"
            />
            {/* </div> */}
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    modalKonfirmasiPembatalan: true
                  }
                });
              }}
              className="btn btn-danger"
            >
              Batalkan Pengajuan
            </button>
            <button
              onClick={() => {
                if (this.state.layanan_jenis) {
                  this.setState({
                    status: {
                      ...this.state.status,
                      frmPreviewDraft: false,
                      frmPrintKonfirmasi: false,
                      modalKodePengajuan: true
                      // frmPrint: true,
                    }
                    // loadingPreview: true,
                  });
                } else {
                  this.setState({
                    status: {
                      ...this.state.status,
                      frmPrintKonfirmasi: false,
                      frmPreviewDraft: false,
                      modalKodePengajuan: true
                    }
                  });
                }
                this.forceUpdate();
              }}
              className="btn btn-success"
            >
              Lanjutkan Pengajuan
            </button>
          </div>
        </Modal>
        {/* End Modal Preview Draft Surat */}

        {/* Modal Konfirmasi Pembatalan Pengajuan Surat */}
        <Modal
          open={this.state.status.modalKonfirmasiPembatalan}
          styles={{ modal: { width: "400px" } }}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                frmPreviewDraft: true,
                modalKonfirmasiPembatalan: false
              }
            });
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              <h3>Apakah anda yakin ingin membatalkan pengajuan?</h3>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.status,
                    frmPreviewDraft: true,
                    modalKonfirmasiPembatalan: false
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-danger"
            >
              Tidak
            </button>
            <button
              onClick={() => {
                this.batalPengajuan();
              }}
              className="btn btn-success"
            >
              Ya
            </button>
          </div>
        </Modal>
        {/* End Modal Konfirmasi Pembatalan Pengajuan Surat */}

        {/* Modal Cetak Surat */}
        <Modal
          classNames={{ overlay: "custom-map-modal" }}
          open={this.state.status.frmPrint}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                modalKonfirmasi: true,
                frmPrint: false
              }
            });
          }}
          styles={{
            modal: {
              width: "100%",
              height: "100%",
              maxHeight: "unset",
              maxWidth: "unset"
            }
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              height: "90%",
              alignItems: "center"
            }}
          >
            <span>
              <h4>
                <b>
                  Pilih gambar <i class="fa fa-print"></i> untuk mencetak surat
                  yang telah anda buat
                </b>
              </h4>
            </span>
            <br />
            {/* <div className="row" style={{ textAlign: 'center' }}> */}
            {/* <h5>Silahkan menunggu nomor antrian anda dipanggil untuk mengambil surat. Terima kasih</h5> */}
            {/* <h3>Apakah anda ingin membuat surat lagi ?</h3> */}

            <Iframe
              id="myFrame"
              src={
                API_URL +
                // 'cetak-surat/' +
                this.state.get_jenis_surat +
                // '/' +
                this.state.get_data_surat.uuid_surat +
                "?show=Ya"
              }
              // styles={
              // 	{display: 'none'}
              // }
              onLoad={e => {
                this.setState({
                  loadingPreview: false
                });
              }}
              width="100%"
              height="100%"
              className="myClassname"
              display={this.state.loadingPreview ? "none" : "block"}
              position="relative"
            />
            {/* </div> */}
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                if (this.state.cek_pengajuan) {
                  // Jika Cek Pengajuan
                  this.setState({
                    status: {
                      ...this.state.status,
                      frmPrint: false
                    }
                  });
                } else {
                  this.setState({
                    status: {
                      ...this.state.status,
                      modalKonfirmasi: true,
                      frmPrint: false
                    }
                  });
                }
                this.forceUpdate();
              }}
              className="btn btn-success"
            >
              Tutup
            </button>
            {/* <button
							onClick={() => {
								this.state.status.modalKonfirmasi = false;
								this.forceUpdate();
							}}
							className="btn btn-primary"
						>
							Buat surat lagi
						</button>
						<button onClick={this.logOut.bind(this)} className="btn btn-success">
							Tidak
						</button> */}
          </div>
        </Modal>
        {/* End Modal Cetak Surat */}

        {/* Modal Kode Pengajuan */}
        <Modal
          open={this.state.status.modalKodePengajuan}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                modalKodePengajuan: false,
                modalKonfirmasi: true
              }
            });
          }}
          styles={{ modal: { width: "500px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              <center>
                <h4>Kode Pengajuan anda adalah:</h4>
                <br />
                <h3>
                  <b>{this.state.get_data_surat.kode_surat}</b>
                </h3>
                <br />
                <br />
                <h5>
                  Gunakan kode pengajuan ini untuk melihat status ataupun
                  mencetak surat yang anda ajukan
                </h5>
              </center>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    modalKodePengajuan: false,
                    modalKonfirmasi: true
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-info"
            >
              Tutup
            </button>
            {this.state.layanan_jenis ? (
              <button
                onClick={() => {
                  this.setState({
                    status: {
                      ...this.state.status,
                      frmPrintKonfirmasi: false,
                      modalKodePengajuan: false,
                      frmPrint: true
                    },
                    loadingPreview: true
                  });
                  this.forceUpdate();
                }}
                className="btn btn-success"
              >
                Cetak Sekarang
              </button>
            ) : (
              <></>
            )}
          </div>
        </Modal>
        {/* End Modal Kode Pengajuan */}

        {/* Modal Cek Status Pengajuan */}
        <Modal
          open={this.state.status.frmCekPengajuan}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                frmCekPengajuan: false
              }
            });
          }}
          styles={{ modal: { width: "440px", height: "240px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Form onSubmit={this.cariPengajuan}>
              <div className="modal-header">
                <h5 className="modal-title">Masukkan kode pengajuan anda</h5>
              </div>

              <div className="modal-body">
                <FormGroup className="row">
                  <Col sm="12">
                    <input
                      className="form-control"
                      id="kode_pengajuan"
                      placeholder="Isi kode pengajuan disini"
                      type="text"
                      required
                      autoFocus
                    />
                  </Col>
                </FormGroup>

                <div className="modal-footer" style={footerStyle}>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => this.tutupCariPengajuan()}
                  >
                    Tutup
                  </button>
                  <button type="submit" className="btn btn-success">
                    Lanjutkan
                  </button>
                </div>
              </div>
            </Form>
          </div>
          {/* <div
							className="modal-footer"
							style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
						>
							<button
								onClick={() => {
									this.tutupCariPengajuan();
								}}
								className="btn btn-danger"
							>
								Tutup
							</button>
							<button
								onClick={() => {
									this.cariPengajuan();
								}}
								className="btn btn-success"
							>
								Lanjutkan
							</button>
						</div> */}
        </Modal>
        {/* End Modal Cek Status Pengajuan */}

        {/* Modal Konfirmasi Cetak */}
        <Modal
          open={this.state.status.modalStatusTerakhir}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                modalStatusTerakhir: false
              }
            });
          }}
          styles={{ modal: { width: "600px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            id="kertas_antrian"
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              <h5 style={{ fontSize: "22px" }}>
                <h5>Status Pengajuan Anda</h5>
                <h4>
                  <b>{this.state.get_data_surat.status_pengajuan}</b>
                </h4>
                {this.state.get_data_surat.status_pengajuan === "Selesai" ? (
                  <h5>
                    Apakah Anda Ingin Mencetak Surat Yang Telah Anda Buat?
                  </h5>
                ) : (
                  <h5>Silahkan Hubungi Petugas Untuk Informasi Lebih Lanjut</h5>
                )}
              </h5>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    modalStatusTerakhir: false
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-warning"
            >
              Tutup
            </button>

            {this.state.get_data_surat.status_pengajuan === "Selesai" ? (
              <button
                onClick={() => {
                  this.setState({
                    status: {
                      ...this.state.status,
                      modalStatusTerakhir: false,
                      frmPrint: true
                    },
                    loadingPreview: true
                  });
                  this.forceUpdate();
                }}
                className="btn btn-info"
              >
                Cetak Sekarang
              </button>
            ) : (
              <></>
            )}
          </div>
        </Modal>
        {/* End Modal Konfirmasi Cetak */}

        {/* Modal Pengajuan Surat Lagi */}

        <Modal
          open={this.state.status.modalKonfirmasi}
          // open={true}
          // open={true}
          onClose={() => {
            this.setState({
              status: {
                ...this.state.status,
                modalKonfirmasi: false
              }
            });
          }}
          styles={{ modal: { width: "400px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              {/* <h5>Silahkan menunggu nomor antrian anda dipanggil untuk mengambil surat. Terima kasih</h5> */}
              <h3>Apakah anda ingin membuat surat lagi ?</h3>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.state.status,
                    modalKonfirmasi: false
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-info"
            >
              Buat surat lagi
            </button>
            <button
              onClick={this.logOut.bind(this)}
              className="btn btn-success"
            >
              Tidak
            </button>
          </div>
        </Modal>

        {/* Modal Pengajuan Surat Lagi */}

        {/* Modal Pemberitahuan Logout */}

        <Modal
          open={this.state.status.modalKonfirmasi2}
          // open={true}
          // open={true}
          onClose={false}
          styles={{ modal: { width: "400px" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div
            className="modal-body"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div className="row" style={{ textAlign: "center" }}>
              <h3>Apakah anda yakin ingin keluar ?</h3>
            </div>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button
              onClick={this.logOut.bind(this)}
              className="btn btn-success"
            >
              Ya
            </button>
            <button
              onClick={() => {
                this.setState({
                  status: {
                    ...this.status,
                    modalKonfirmasi2: false
                  }
                });
                this.forceUpdate();
              }}
              className="btn btn-info"
            >
              Tidak
            </button>
          </div>
        </Modal>

        {/* End Modal Pemberitahuan Logout */}
      </>
    );
  }
}
